import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

console.log('React app is starting...');

// Ensure the root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("Root element not found. Ensure there's a <div id='root'></div> in index.html.");
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If there are issues in App.jsx, they may show up here
reportWebVitals(console.log);
